import React from "react";

import {
  useEffect,
} from "react";


import {
  usePrivacy,
} from "../hooks/usePrivacy";


import {
  loadScript,
  removeScript,
} from "../services/scriptLoader";



export function PrivacyAutoScripts(){


  const {
    services,
    checkServiceConsent,
    hasConsent,
  } =
    usePrivacy();




  useEffect(() => {


    /*
      Aspetta che il consenso salvato
      sia stato caricato dallo storage
    */

    if(!hasConsent){

      return;

    }



    services.forEach(
      service => {


        const allowed =
          checkServiceConsent(
            service.id
          );



        if(!allowed){


          service.scripts?.forEach(
            script => {


              removeScript(
                script.id
              );


            }
          );


          return;

        }




        service.scripts?.forEach(
          script => {


            loadScript(
              script
            );


          }
        );


      }
    );



  },[
    services,
    checkServiceConsent,
    hasConsent
  ]);



  return null;

}